import React, { useEffect, useState, useRef } from "react";
import Media from "react-media";
import { Button } from "react-bootstrap";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { useFormik } from "formik";

import OtherSettingsExp from "./OtherSettingsExp";
import ExperienceBooking from "./ExperienceBooking";
import GeneralInformationExp from "./GeneralInfoExp";
import ExperienceData from "./ExperienceData";
import { amApi } from "../../../../api/apiHelper";
import { useHistory } from "react-router-dom";
import { errorAlert, successAlert } from "../../../../function/alert";
import moment from "moment";
import * as yup from "yup";
import { validateTimings } from "../../../../function/timingsValdations";


const EditExperience = () => {
  const [selectedTab, setSelectedTab] = useState(1);
  const history = useHistory();
  const [editData, setEditData] = useState({});
  const [count, setCount] = useState(1);
  const id = history?.location?.pathname?.split('/')[2];
  const expType = history?.location?.pathname.includes('Special') ? "SPECIAL" : "CURATED";


  const formik3 = useFormik({
    initialValues: ExperienceData.f3intialvalues,
    validationSchema: yup.object({
      autoAcceptPax: yup.number(),
      // .positive()
      // .min(1, "Min pax must be greater than or equal to 1")
      // .required("pax limit is required"),
    }),

    onSubmit: (values) => {
      values.expType = expType;
      let formData = {
        ...formik1.values,
        seatsBooked: 0,
        seatsLeft: 0,
        ...formik2.values,
        ...formik3.values,
      };
      let classifications = [];
      formData.classification.map((e) => classifications.push(e?._id));
      formData.classification = classifications;
      if (values?.autoAccept && values?.autoAcceptPax < formData.minSeats) {
        formik3.setFieldError(
          "autoAcceptPax",
          `Min pax must be greater than or equal to ${formData.minSeats}`
        );
      } else {
        amApi.patch(`/experience/${id}`, formData).then(res => {
          successAlert('Experience Updated Successfully');
          history.push(`${expType === "CURATED" ? '/curatedDashboard' : '/specialDashboard'}`);
          formik1.resetForm();
          formik2.resetForm();
          formik3.resetForm();

        }).catch(err => {
          errorAlert(err?.response?.data?.message || "Something went wrong, try again later")
        });
      }
    },
  });

  const formik1 = useFormik({
    initialValues: ExperienceData.f1initialValues,
    validationSchema: ExperienceData.f1validations,
    onSubmit: (values) => {
      let validate = validateTimings(values.timings);
      if (validate) {
        handleTab(2);
      } else {
        errorAlert('Please select proper timings.')
      }
    },
  });

  const formik2 = useFormik({
    initialValues: ExperienceData.f2initialValues,
    validationSchema: ExperienceData.f2validations,
    onSubmit: (values) => {
      if (!formik1?.values?.ageRestriction && values?.allowSingleBooking && values?.kidsPrice <= 0) {
        formik2.setFieldError("kidsPrice", "Min price cannot be less than 1");
      } else if (expType === "CURATED" && values?.allowSingleBooking && values?.minSeats <= 0) {
        formik2.setFieldError("minSeats", "Minimum 1 seat is required");
      } else if (expType === "CURATED" && values?.allowSingleBooking && values?.maxSeats <= 0) {
        formik2.setFieldError("maxSeats", "Maximum seats required");
      } else if (expType === "CURATED" && values?.allowSingleBooking && values?.maxSeats > values?.totalSeats) {
        formik2.setFieldError("maxSeats", "Maximum seats should be less than or equal to total seats");
      } else if (!values?.allowSingleBooking && !values?.isPackagesProvided) {
        errorAlert("Please select any of the single ticket or package.")
      } else if (values.isPackagesProvided && values.packages.length === 0) {
        errorAlert("Please create at least one package.")
      } else {
        handleTab(3);
      }
    },
  });

  const onClickForm1Save = () => {
    setCount(count + 1);
    formik1.handleSubmit();
  };
  const onClickForm2Save = () => {
    setCount(count + 1);
    formik2.handleSubmit();
  };
  const onClickForm3Save = (e) => {
    // e.preventDefault();
    setCount(count + 1);
    formik3.handleSubmit();
  };


  const prevCopyTimings = useRef();
  const prevStartDate = useRef();
  const prevEndDate = useRef();

  useEffect(() => {
    prevCopyTimings.current = formik1.values.copyTimings;
  }, [formik1.values.copyTimings])

  useEffect(() => {
    prevStartDate.current = formik1.values.startDate;
  }, [formik1.values.startDate])

  useEffect(() => {
    prevEndDate.current = formik1.values.endDate;
  }, [formik1.values.endDate])

  useEffect(() => {
    async function fetchData() {
      let expData = await amApi.get(`/experience/${id}`);
      expData = expData.data;
      formik1.setValues({
        category: expData?.category?._id,
        subCategory: expData?.subCategory?._id,
        classification: expData?.classification,
        expType: expType,
        name: expData?.name,
        description: expData?.description,
        primary: expData?.primary,
        startDate: moment(expData?.endDate).isAfter(moment()) ? moment(expData?.startDate).format('YYYY-MM-DD') : "",
        endDate: moment(expData?.endDate).isAfter(moment()) ? moment(expData?.endDate).format('YYYY-MM-DD') : "",
        userBenefits: expData?.userBenefits,
        photos: expData?.photos,
        photoThumbnails: expData?.photoThumbnails,
        timings: moment(expData?.endDate).isAfter(moment()) ? expData.timings : ExperienceData?.initialValues.timings,
        tc: expData?.tc,
        active: expData?.active,
        venueAddress: expData?.venueAddress,
        venue: expData?.venue,
        ageRestriction: expData?.ageRestriction,
        serveFood: expData?.serveFood,
        foodItems: expData?.foodItems || "",
        minAge: expData?.minAge || 0,
        videos: expData?.videos || [],
        tags: expData?.tags || [],
      });
      formik2.setValues({
        seatsBooked: expData?.seatsBooked || 0,
        seatsLeft: expData?.seatsLeft || 0,
        ticketName: expData?.ticketName,
        adultPrice: expData?.adultPrice || 0,
        kidsPrice: expData?.kidsPrice || 0,
        totalSeats: expData?.totalSeats || 0,
        minSeats: expData?.minSeats || 0, // Seats for Booking
        maxSeats: expData?.maxSeats || 0, // Seats for Booking
        ticketDesc: expData?.ticketDesc || "",
        vendorId: expData?.vendorId,
        packages: expData?.packages,
        isPackagesProvided: expData?.isPackagesProvided,
        allowSingleBooking: expData?.allowSingleBooking,
        refundDesc: expData?.refundDesc || "",
        addOnAvailable: expData?.addOnAvailable || false,
        addOnDesc: expData?.addOnDesc || "",
        rescheduleAllowed: expData?.rescheduleAllowed || false,
      });
      formik3.setValues({
        highchairAccess: expData?.highchairAccess,
        handicapAccess: expData?.handicapAccess,
        sameAddress: expData?.sameAddress,
        autoAccept: expData?.autoAccept,
        autoAcceptPax: expData?.autoAcceptPax,
        sameDayBooking: expData?.sameDayBooking,
        maxDaysAhead: expData?.maxDaysAhead,
        bookingTimeSlot: expData?.bookingTimeSlot,
        autoCancel: expData?.autoCancel,
        seatingPreference: expData?.seatingPreference,
      });
      setEditData(expData?.data);
    }
    if (id) {
      fetchData()
    }
  }, [])

  const handleTab = (e) => {
    setSelectedTab(e);
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="right-side-panel">
            <Media query="(max-width: 992px)">
              <RightSideNavigation backButtonLink="/back" />
            </Media>
            <Media query="(min-width: 992px)">
              <RightSideNavigation
                // displayButton="addOffer"
                leftText="vendorReview"
                backButtonLink={() => history.goBack()}
                displayText="Back"
                actionPerform="button"
              />
            </Media>
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  {`Edit ${expType === 'SPECIAL' ? "Occasions" : "Events"}`}
                </div>
              </div>
              <div className="d-flex align-items-center">
                <Button
                  variant="link"
                  className={`px-0 mr-2 text-grayLink f10-500 ${selectedTab === 1 ? "active" : ""
                    }`}
                // onClick={() => handleTab(1)}
                >
                  General Information
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-2 text-grayLink f10-500 ${selectedTab === 2 ? "active" : ""
                    }`}
                // onClick={() => handleTab(2)}
                >
                  Experience Booking
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-2 text-grayLink f10-500 ${selectedTab === 3 ? "active" : ""
                    }`}
                // onClick={() => handleTab(3)}
                >
                  Other Settings
                </Button>
              </div>
              <hr />
              {selectedTab === 1 ? (
                <GeneralInformationExp
                  prevCopyTimings={prevCopyTimings}
                  prevStartDate={prevStartDate}
                  prevEndDate={prevEndDate}
                  formik={formik1}
                  expType={expType}
                  count={count}
                  cloneExp={true}
                  setExpClone={() => { }}
                  editMode={true}
                />
              ) : selectedTab === 2 ? (
                <ExperienceBooking
                  formik={formik2}
                  ageRestriction={formik1?.values?.ageRestriction}
                  expType={expType}
                  count={count}
                />
              ) : (
                <OtherSettingsExp
                  ageRestriction={formik1?.values?.ageRestriction}
                  formik={formik3}
                  expType={expType}
                  count={count}
                />
              )}
            </div>
            <div className="py-4 d-flex align-items-center">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5 btn150px"
                type="button"
                onClick={() => {
                  if (selectedTab === 1) {
                    history.push(
                      `${expType === "CURATED"
                        ? "/curatedDashboard"
                        : "/specialDashboard"
                      }`
                    );
                  } else {
                    handleTab(selectedTab - 1);
                  }
                }}
              >
                {selectedTab === 1 ? "Cancel" : "Back"}
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5 btn150px"
                type="button"
                onClick={() => {
                  if (selectedTab === 3) {
                    onClickForm3Save();
                  } else if (selectedTab === 2) {
                    onClickForm2Save();
                  } else {
                    onClickForm1Save();
                  }
                  //  setCount(count + 1);
                  //  formik.validateForm()
                }}
              >
                {selectedTab === 3 ? "Save" : "Next"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EditExperience;






